{
  "formatVersion": 1,
  "name": "blackline-kasbah",
  "displayName": "Kasbah",
  "description": "A sun-baked plaster compound at golden hour: two walled team courtyards, a market square with a fountain and stalls, and terraces of two-storey houses with open roof decks overlooking the square. ",
  "visual": null,
  "environment": "golden",
  "brushes": [
    {
      "kind": "box",
      "center": [
        0,
        -0.5,
        0
      ],
      "halfExtents": [
        41,
        0.5,
        30
      ],
      "material": "sand",
      "note": "kasbah sand floor"
    },
    {
      "kind": "box",
      "center": [
        0,
        2.5,
        -29.75
      ],
      "halfExtents": [
        41,
        2.5,
        0.25
      ],
      "material": "plaster",
      "note": "perimeter north wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        2.5,
        29.75
      ],
      "halfExtents": [
        41,
        2.5,
        0.25
      ],
      "material": "plaster",
      "note": "perimeter south wall"
    },
    {
      "kind": "box",
      "center": [
        40.75,
        2.5,
        0
      ],
      "halfExtents": [
        0.25,
        2.5,
        29.5
      ],
      "material": "plaster",
      "note": "perimeter east wall"
    },
    {
      "kind": "box",
      "center": [
        -40.75,
        2.5,
        0
      ],
      "halfExtents": [
        0.25,
        2.5,
        29.5
      ],
      "material": "plaster",
      "note": "perimeter west wall"
    },
    {
      "kind": "box",
      "center": [
        -39,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -37,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -35,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -33,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -31,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -29,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -27,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -25,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -23,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -21,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -19,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -17,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -15,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -13,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -11,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -9,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -7,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -5,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -3,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -1,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        1,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        3,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        5,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        7,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        9,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        11,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        13,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        15,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        17,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        19,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        21,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        23,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        25,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        27,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        29,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        31,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        33,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        35,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        37,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        39,
        4.6,
        -30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -39,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -37,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -35,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -33,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -31,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -29,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -27,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -25,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -23,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -21,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -19,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -17,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -15,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -13,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -11,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -9,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -7,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -5,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -3,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -1,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        1,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        3,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        5,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        7,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        9,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        11,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        13,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        15,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        17,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        19,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        21,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        23,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        25,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        27,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        29,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        31,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        33,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        35,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        37,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        39,
        4.6,
        30.35
      ],
      "halfExtents": [
        0.075,
        0.075,
        0.35
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -28
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -26
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -24
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -22
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -20
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -18
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -16
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -14
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -12
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -10
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -8
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -6
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -4
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        -2
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        0
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        2
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        4
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        6
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        8
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        10
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        12
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        14
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        16
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        18
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        20
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        22
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        24
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        26
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -41.35,
        4.6,
        28
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -28
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -26
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -24
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -22
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -20
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -18
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -16
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -14
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -12
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -10
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -8
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -6
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -4
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        -2
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        0
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        2
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        4
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        6
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        8
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        10
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        12
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        14
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        16
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        18
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        20
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        22
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        24
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        26
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        41.35,
        4.6,
        28
      ],
      "halfExtents": [
        0.35,
        0.075,
        0.075
      ],
      "material": "wood",
      "note": "beam end"
    },
    {
      "kind": "box",
      "center": [
        -36,
        4,
        -25
      ],
      "halfExtents": [
        2.5,
        4,
        2.5
      ],
      "material": "brick",
      "note": "corner tower"
    },
    {
      "kind": "box",
      "center": [
        36,
        4,
        25
      ],
      "halfExtents": [
        2.5,
        4,
        2.5
      ],
      "material": "brick",
      "note": "corner tower"
    },
    {
      "kind": "box",
      "center": [
        0,
        -0.14,
        0
      ],
      "halfExtents": [
        11,
        0.15,
        8
      ],
      "material": "tile",
      "note": "plaza floor"
    },
    {
      "kind": "box",
      "center": [
        0,
        0.45,
        4
      ],
      "halfExtents": [
        3,
        0.45,
        3
      ],
      "material": "tile",
      "note": "fountain plinth"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.2,
        4
      ],
      "halfExtents": [
        0.12,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffe3b0",
      "emissiveIntensity": 3,
      "note": "fountain lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -8,
        2.3,
        6
      ],
      "halfExtents": [
        0.1,
        0.04,
        0.1
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "stall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -8,
        2.3,
        -6
      ],
      "halfExtents": [
        0.1,
        0.04,
        0.1
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "stall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -8,
        1.1,
        6
      ],
      "halfExtents": [
        1.25,
        1.1,
        1.25
      ],
      "material": "plaster",
      "note": "market stall"
    },
    {
      "kind": "box",
      "center": [
        -8,
        2.55,
        6
      ],
      "halfExtents": [
        1.5,
        0.05,
        1.5
      ],
      "material": "wood",
      "note": "stall awning"
    },
    {
      "kind": "box",
      "center": [
        -6.6,
        1.25,
        7.4
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        -6.6,
        1.25,
        4.6
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        -9.4,
        1.25,
        7.4
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        -9.4,
        1.25,
        4.6
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.1,
        -6
      ],
      "halfExtents": [
        1.25,
        1.1,
        1.25
      ],
      "material": "plaster",
      "note": "market stall"
    },
    {
      "kind": "box",
      "center": [
        8,
        2.55,
        -6
      ],
      "halfExtents": [
        1.5,
        0.05,
        1.5
      ],
      "material": "wood",
      "note": "stall awning"
    },
    {
      "kind": "box",
      "center": [
        6.6,
        1.25,
        -7.4
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        6.6,
        1.25,
        -4.6
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        9.4,
        1.25,
        -7.4
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        9.4,
        1.25,
        -4.6
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        -8,
        1.1,
        -6
      ],
      "halfExtents": [
        1.25,
        1.1,
        1.25
      ],
      "material": "plaster",
      "note": "market stall"
    },
    {
      "kind": "box",
      "center": [
        -8,
        2.55,
        -6
      ],
      "halfExtents": [
        1.5,
        0.05,
        1.5
      ],
      "material": "wood",
      "note": "stall awning"
    },
    {
      "kind": "box",
      "center": [
        -6.6,
        1.25,
        -4.6
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        -6.6,
        1.25,
        -7.4
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        -9.4,
        1.25,
        -4.6
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        -9.4,
        1.25,
        -7.4
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.1,
        6
      ],
      "halfExtents": [
        1.25,
        1.1,
        1.25
      ],
      "material": "plaster",
      "note": "market stall"
    },
    {
      "kind": "box",
      "center": [
        8,
        2.55,
        6
      ],
      "halfExtents": [
        1.5,
        0.05,
        1.5
      ],
      "material": "wood",
      "note": "stall awning"
    },
    {
      "kind": "box",
      "center": [
        6.6,
        1.25,
        4.6
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        6.6,
        1.25,
        7.4
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        9.4,
        1.25,
        4.6
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        9.4,
        1.25,
        7.4
      ],
      "halfExtents": [
        0.05,
        1.25,
        0.05
      ],
      "material": "wood",
      "note": "awning post"
    },
    {
      "kind": "box",
      "center": [
        -16,
        -0.04,
        0
      ],
      "halfExtents": [
        5,
        0.06,
        1.5
      ],
      "material": "tile",
      "note": "west approach path"
    },
    {
      "kind": "box",
      "center": [
        16,
        -0.04,
        0
      ],
      "halfExtents": [
        5,
        0.06,
        1.5
      ],
      "material": "tile",
      "note": "west approach path"
    },
    {
      "kind": "box",
      "center": [
        -6.5,
        0.4,
        7.5
      ],
      "halfExtents": [
        0.6,
        0.4,
        0.4
      ],
      "material": "wood",
      "hidden": true,
      "note": "crate collision"
    },
    {
      "kind": "box",
      "center": [
        6.5,
        0.4,
        -7.5
      ],
      "halfExtents": [
        0.6,
        0.4,
        0.4
      ],
      "material": "wood",
      "hidden": true,
      "note": "crate collision"
    },
    {
      "kind": "box",
      "center": [
        -21,
        2.4,
        -3.5
      ],
      "halfExtents": [
        0.25,
        0.05,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "gate lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -21,
        2.4,
        1.5
      ],
      "halfExtents": [
        0.25,
        0.05,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "gate lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -30,
        1.75,
        -6.8
      ],
      "halfExtents": [
        9,
        1.75,
        0.2
      ],
      "material": "plaster",
      "note": "quarter wall north wall"
    },
    {
      "kind": "box",
      "center": [
        -30,
        1.75,
        6.8
      ],
      "halfExtents": [
        9,
        1.75,
        0.2
      ],
      "material": "plaster",
      "note": "quarter wall south wall"
    },
    {
      "kind": "box",
      "center": [
        -21.2,
        1.75,
        -5.65
      ],
      "halfExtents": [
        0.2,
        1.75,
        0.95
      ],
      "material": "plaster",
      "note": "quarter wall east wall"
    },
    {
      "kind": "box",
      "center": [
        -21.2,
        3.05,
        -3.5
      ],
      "halfExtents": [
        0.2,
        0.45,
        1.2
      ],
      "material": "plaster",
      "note": "quarter wall east lintel"
    },
    {
      "kind": "box",
      "center": [
        -21.2,
        1.75,
        -1
      ],
      "halfExtents": [
        0.2,
        1.75,
        1.3
      ],
      "material": "plaster",
      "note": "quarter wall east wall"
    },
    {
      "kind": "box",
      "center": [
        -21.2,
        3.05,
        1.5
      ],
      "halfExtents": [
        0.2,
        0.45,
        1.2
      ],
      "material": "plaster",
      "note": "quarter wall east lintel"
    },
    {
      "kind": "box",
      "center": [
        -21.2,
        1.75,
        4.65
      ],
      "halfExtents": [
        0.2,
        1.75,
        1.95
      ],
      "material": "plaster",
      "note": "quarter wall east wall"
    },
    {
      "kind": "box",
      "center": [
        -38.8,
        1.75,
        0
      ],
      "halfExtents": [
        0.2,
        1.75,
        6.6
      ],
      "material": "plaster",
      "note": "quarter wall west wall"
    },
    {
      "kind": "box",
      "center": [
        -30,
        -0.14,
        0
      ],
      "halfExtents": [
        9,
        0.15,
        7
      ],
      "material": "gravel",
      "note": "courtyard floor"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.5,
        0
      ],
      "halfExtents": [
        0.8,
        0.5,
        0.8
      ],
      "material": "brick",
      "note": "well"
    },
    {
      "kind": "box",
      "center": [
        -19,
        1.4,
        -3.5
      ],
      "halfExtents": [
        0.2,
        1.4,
        1.7
      ],
      "material": "plaster",
      "note": "gate baffle"
    },
    {
      "kind": "box",
      "center": [
        -19,
        1.4,
        1.5
      ],
      "halfExtents": [
        0.2,
        1.4,
        1.7
      ],
      "material": "plaster",
      "note": "gate baffle"
    },
    {
      "kind": "box",
      "center": [
        -38,
        0.25,
        -6
      ],
      "halfExtents": [
        0.6,
        0.25,
        0.6
      ],
      "material": "sand",
      "note": "planter"
    },
    {
      "kind": "box",
      "center": [
        -38,
        0.25,
        6
      ],
      "halfExtents": [
        0.6,
        0.25,
        0.6
      ],
      "material": "sand",
      "note": "planter"
    },
    {
      "kind": "box",
      "center": [
        -22,
        0.25,
        -6
      ],
      "halfExtents": [
        0.6,
        0.25,
        0.6
      ],
      "material": "sand",
      "note": "planter"
    },
    {
      "kind": "box",
      "center": [
        -22,
        0.25,
        6
      ],
      "halfExtents": [
        0.6,
        0.25,
        0.6
      ],
      "material": "sand",
      "note": "planter"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.4,
        -4.5
      ],
      "halfExtents": [
        0.4,
        0.4,
        0.4
      ],
      "material": "wood",
      "hidden": true,
      "note": "crate collision"
    },
    {
      "kind": "box",
      "center": [
        30,
        1.75,
        6.8
      ],
      "halfExtents": [
        9,
        1.75,
        0.2
      ],
      "material": "plaster",
      "note": "quarter wall north wall"
    },
    {
      "kind": "box",
      "center": [
        30,
        1.75,
        -6.8
      ],
      "halfExtents": [
        9,
        1.75,
        0.2
      ],
      "material": "plaster",
      "note": "quarter wall south wall"
    },
    {
      "kind": "box",
      "center": [
        21.2,
        1.75,
        5.65
      ],
      "halfExtents": [
        0.2,
        1.75,
        0.95
      ],
      "material": "plaster",
      "note": "quarter wall east wall"
    },
    {
      "kind": "box",
      "center": [
        21.2,
        3.05,
        3.5
      ],
      "halfExtents": [
        0.2,
        0.45,
        1.2
      ],
      "material": "plaster",
      "note": "quarter wall east lintel"
    },
    {
      "kind": "box",
      "center": [
        21.2,
        1.75,
        1
      ],
      "halfExtents": [
        0.2,
        1.75,
        1.3
      ],
      "material": "plaster",
      "note": "quarter wall east wall"
    },
    {
      "kind": "box",
      "center": [
        21.2,
        3.05,
        -1.5
      ],
      "halfExtents": [
        0.2,
        0.45,
        1.2
      ],
      "material": "plaster",
      "note": "quarter wall east lintel"
    },
    {
      "kind": "box",
      "center": [
        21.2,
        1.75,
        -4.65
      ],
      "halfExtents": [
        0.2,
        1.75,
        1.95
      ],
      "material": "plaster",
      "note": "quarter wall east wall"
    },
    {
      "kind": "box",
      "center": [
        38.8,
        1.75,
        0
      ],
      "halfExtents": [
        0.2,
        1.75,
        6.6
      ],
      "material": "plaster",
      "note": "quarter wall west wall"
    },
    {
      "kind": "box",
      "center": [
        30,
        -0.14,
        0
      ],
      "halfExtents": [
        9,
        0.15,
        7
      ],
      "material": "gravel",
      "note": "courtyard floor"
    },
    {
      "kind": "box",
      "center": [
        30,
        0.5,
        0
      ],
      "halfExtents": [
        0.8,
        0.5,
        0.8
      ],
      "material": "brick",
      "note": "well"
    },
    {
      "kind": "box",
      "center": [
        19,
        1.4,
        3.5
      ],
      "halfExtents": [
        0.2,
        1.4,
        1.7
      ],
      "material": "plaster",
      "note": "gate baffle"
    },
    {
      "kind": "box",
      "center": [
        19,
        1.4,
        -1.5
      ],
      "halfExtents": [
        0.2,
        1.4,
        1.7
      ],
      "material": "plaster",
      "note": "gate baffle"
    },
    {
      "kind": "box",
      "center": [
        38,
        0.25,
        6
      ],
      "halfExtents": [
        0.6,
        0.25,
        0.6
      ],
      "material": "sand",
      "note": "planter"
    },
    {
      "kind": "box",
      "center": [
        38,
        0.25,
        -6
      ],
      "halfExtents": [
        0.6,
        0.25,
        0.6
      ],
      "material": "sand",
      "note": "planter"
    },
    {
      "kind": "box",
      "center": [
        22,
        0.25,
        6
      ],
      "halfExtents": [
        0.6,
        0.25,
        0.6
      ],
      "material": "sand",
      "note": "planter"
    },
    {
      "kind": "box",
      "center": [
        22,
        0.25,
        -6
      ],
      "halfExtents": [
        0.6,
        0.25,
        0.6
      ],
      "material": "sand",
      "note": "planter"
    },
    {
      "kind": "box",
      "center": [
        30,
        0.4,
        4.5
      ],
      "halfExtents": [
        0.4,
        0.4,
        0.4
      ],
      "material": "wood",
      "hidden": true,
      "note": "crate collision"
    },
    {
      "kind": "box",
      "center": [
        -8,
        2.8,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.04,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffd8a0",
      "emissiveIntensity": 3,
      "note": "house interior lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        0,
        2.8,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.04,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffd8a0",
      "emissiveIntensity": 3,
      "note": "house interior lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        8,
        2.8,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.04,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffd8a0",
      "emissiveIntensity": 3,
      "note": "house interior lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -10.3,
        1.45,
        -14.85
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house -8 north wall"
    },
    {
      "kind": "box",
      "center": [
        -8,
        2.55,
        -14.85
      ],
      "halfExtents": [
        0.6,
        0.35,
        0.15
      ],
      "material": "plaster",
      "note": "house -8 north lintel"
    },
    {
      "kind": "box",
      "center": [
        -5.7,
        1.45,
        -14.85
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house -8 north wall"
    },
    {
      "kind": "box",
      "center": [
        -10.3,
        1.45,
        -8.15
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house -8 south wall"
    },
    {
      "kind": "box",
      "center": [
        -8,
        2.55,
        -8.15
      ],
      "halfExtents": [
        0.6,
        0.35,
        0.15
      ],
      "material": "plaster",
      "note": "house -8 south lintel"
    },
    {
      "kind": "box",
      "center": [
        -5.7,
        1.45,
        -8.15
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house -8 south wall"
    },
    {
      "kind": "box",
      "center": [
        -4.15,
        1.45,
        -13.4
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house -8 east wall"
    },
    {
      "kind": "box",
      "center": [
        -4.15,
        0.5,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.6
      ],
      "material": "plaster",
      "note": "house -8 east sill"
    },
    {
      "kind": "box",
      "center": [
        -4.15,
        2.45,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.45,
        0.6
      ],
      "material": "plaster",
      "note": "house -8 east lintel"
    },
    {
      "kind": "box",
      "center": [
        -4.15,
        1.45,
        -9.6
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house -8 east wall"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        1.45,
        -13.4
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house -8 west wall"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        0.5,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.6
      ],
      "material": "plaster",
      "note": "house -8 west sill"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        2.45,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.45,
        0.6
      ],
      "material": "plaster",
      "note": "house -8 west lintel"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        1.45,
        -9.6
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house -8 west wall"
    },
    {
      "kind": "box",
      "center": [
        -9.5,
        0.4,
        -13.3
      ],
      "halfExtents": [
        0.8,
        0.4,
        0.4
      ],
      "material": "wood",
      "note": "table"
    },
    {
      "kind": "box",
      "center": [
        -6.5,
        0.8,
        -9.7
      ],
      "halfExtents": [
        0.6,
        0.8,
        0.3
      ],
      "material": "brick",
      "note": "hearth"
    },
    {
      "kind": "box",
      "center": [
        -2.3,
        1.45,
        -14.85
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 0 north wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        2.55,
        -14.85
      ],
      "halfExtents": [
        0.6,
        0.35,
        0.15
      ],
      "material": "plaster",
      "note": "house 0 north lintel"
    },
    {
      "kind": "box",
      "center": [
        2.3,
        1.45,
        -14.85
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 0 north wall"
    },
    {
      "kind": "box",
      "center": [
        -2.3,
        1.45,
        -8.15
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 0 south wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        2.55,
        -8.15
      ],
      "halfExtents": [
        0.6,
        0.35,
        0.15
      ],
      "material": "plaster",
      "note": "house 0 south lintel"
    },
    {
      "kind": "box",
      "center": [
        2.3,
        1.45,
        -8.15
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 0 south wall"
    },
    {
      "kind": "box",
      "center": [
        3.85,
        1.45,
        -13.4
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 0 east wall"
    },
    {
      "kind": "box",
      "center": [
        3.85,
        0.5,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.6
      ],
      "material": "plaster",
      "note": "house 0 east sill"
    },
    {
      "kind": "box",
      "center": [
        3.85,
        2.45,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.45,
        0.6
      ],
      "material": "plaster",
      "note": "house 0 east lintel"
    },
    {
      "kind": "box",
      "center": [
        3.85,
        1.45,
        -9.6
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 0 east wall"
    },
    {
      "kind": "box",
      "center": [
        -3.85,
        1.45,
        -13.4
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 0 west wall"
    },
    {
      "kind": "box",
      "center": [
        -3.85,
        0.5,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.6
      ],
      "material": "plaster",
      "note": "house 0 west sill"
    },
    {
      "kind": "box",
      "center": [
        -3.85,
        2.45,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.45,
        0.6
      ],
      "material": "plaster",
      "note": "house 0 west lintel"
    },
    {
      "kind": "box",
      "center": [
        -3.85,
        1.45,
        -9.6
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 0 west wall"
    },
    {
      "kind": "box",
      "center": [
        -1.5,
        0.4,
        -13.3
      ],
      "halfExtents": [
        0.8,
        0.4,
        0.4
      ],
      "material": "wood",
      "note": "table"
    },
    {
      "kind": "box",
      "center": [
        1.5,
        0.8,
        -9.7
      ],
      "halfExtents": [
        0.6,
        0.8,
        0.3
      ],
      "material": "brick",
      "note": "hearth"
    },
    {
      "kind": "box",
      "center": [
        5.7,
        1.45,
        -14.85
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 8 north wall"
    },
    {
      "kind": "box",
      "center": [
        8,
        2.55,
        -14.85
      ],
      "halfExtents": [
        0.6,
        0.35,
        0.15
      ],
      "material": "plaster",
      "note": "house 8 north lintel"
    },
    {
      "kind": "box",
      "center": [
        10.3,
        1.45,
        -14.85
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 8 north wall"
    },
    {
      "kind": "box",
      "center": [
        5.7,
        1.45,
        -8.15
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 8 south wall"
    },
    {
      "kind": "box",
      "center": [
        8,
        2.55,
        -8.15
      ],
      "halfExtents": [
        0.6,
        0.35,
        0.15
      ],
      "material": "plaster",
      "note": "house 8 south lintel"
    },
    {
      "kind": "box",
      "center": [
        10.3,
        1.45,
        -8.15
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 8 south wall"
    },
    {
      "kind": "box",
      "center": [
        11.85,
        1.45,
        -13.4
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 8 east wall"
    },
    {
      "kind": "box",
      "center": [
        11.85,
        0.5,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.6
      ],
      "material": "plaster",
      "note": "house 8 east sill"
    },
    {
      "kind": "box",
      "center": [
        11.85,
        2.45,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.45,
        0.6
      ],
      "material": "plaster",
      "note": "house 8 east lintel"
    },
    {
      "kind": "box",
      "center": [
        11.85,
        1.45,
        -9.6
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 8 east wall"
    },
    {
      "kind": "box",
      "center": [
        4.15,
        1.45,
        -13.4
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 8 west wall"
    },
    {
      "kind": "box",
      "center": [
        4.15,
        0.5,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.6
      ],
      "material": "plaster",
      "note": "house 8 west sill"
    },
    {
      "kind": "box",
      "center": [
        4.15,
        2.45,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.45,
        0.6
      ],
      "material": "plaster",
      "note": "house 8 west lintel"
    },
    {
      "kind": "box",
      "center": [
        4.15,
        1.45,
        -9.6
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 8 west wall"
    },
    {
      "kind": "box",
      "center": [
        6.5,
        0.4,
        -13.3
      ],
      "halfExtents": [
        0.8,
        0.4,
        0.4
      ],
      "material": "wood",
      "note": "table"
    },
    {
      "kind": "box",
      "center": [
        9.5,
        0.8,
        -9.7
      ],
      "halfExtents": [
        0.6,
        0.8,
        0.3
      ],
      "material": "brick",
      "note": "hearth"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.05,
        -11.5
      ],
      "halfExtents": [
        12,
        0.15,
        3.5
      ],
      "material": "wood",
      "note": "roof deck"
    },
    {
      "kind": "box",
      "center": [
        -11.35,
        3.75,
        -14.85
      ],
      "halfExtents": [
        0.65,
        0.55,
        0.15
      ],
      "material": "plaster",
      "note": "roof parapet north wall"
    },
    {
      "kind": "box",
      "center": [
        1.35,
        3.75,
        -14.85
      ],
      "halfExtents": [
        10.65,
        0.55,
        0.15
      ],
      "material": "plaster",
      "note": "roof parapet north wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.75,
        -8.15
      ],
      "halfExtents": [
        12,
        0.55,
        0.15
      ],
      "material": "plaster",
      "note": "roof parapet south wall"
    },
    {
      "kind": "box",
      "center": [
        11.85,
        3.75,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.55,
        3.2
      ],
      "material": "plaster",
      "note": "roof parapet east wall"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        3.75,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.55,
        3.2
      ],
      "material": "plaster",
      "note": "roof parapet west wall"
    },
    {
      "kind": "box",
      "center": [
        -4,
        3.75,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.55,
        3.2
      ],
      "material": "plaster",
      "note": "roof divider parapet"
    },
    {
      "kind": "box",
      "center": [
        4,
        3.75,
        -11.5
      ],
      "halfExtents": [
        0.15,
        0.55,
        3.2
      ],
      "material": "plaster",
      "note": "roof divider parapet"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.075,
        -18.225
      ],
      "halfExtents": [
        0.7,
        0.075,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 1"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.15,
        -18.075
      ],
      "halfExtents": [
        0.7,
        0.15,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 2"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.225,
        -17.925
      ],
      "halfExtents": [
        0.7,
        0.225,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 3"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.3,
        -17.775
      ],
      "halfExtents": [
        0.7,
        0.3,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 4"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.375,
        -17.625
      ],
      "halfExtents": [
        0.7,
        0.375,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 5"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.45,
        -17.475
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 6"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.525,
        -17.325
      ],
      "halfExtents": [
        0.7,
        0.525,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 7"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.6,
        -17.175
      ],
      "halfExtents": [
        0.7,
        0.6,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 8"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.675,
        -17.025
      ],
      "halfExtents": [
        0.7,
        0.675,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 9"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.75,
        -16.875
      ],
      "halfExtents": [
        0.7,
        0.75,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 10"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.825,
        -16.725
      ],
      "halfExtents": [
        0.7,
        0.825,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 11"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.9,
        -16.575
      ],
      "halfExtents": [
        0.7,
        0.9,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 12"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.975,
        -16.425
      ],
      "halfExtents": [
        0.7,
        0.975,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 13"
    },
    {
      "kind": "box",
      "center": [
        -10,
        1.05,
        -16.275
      ],
      "halfExtents": [
        0.7,
        1.05,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 14"
    },
    {
      "kind": "box",
      "center": [
        -10,
        1.125,
        -16.125
      ],
      "halfExtents": [
        0.7,
        1.125,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 15"
    },
    {
      "kind": "box",
      "center": [
        -10,
        1.2,
        -15.975
      ],
      "halfExtents": [
        0.7,
        1.2,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 16"
    },
    {
      "kind": "box",
      "center": [
        -10,
        1.275,
        -15.825
      ],
      "halfExtents": [
        0.7,
        1.275,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 17"
    },
    {
      "kind": "box",
      "center": [
        -10,
        1.35,
        -15.675
      ],
      "halfExtents": [
        0.7,
        1.35,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 18"
    },
    {
      "kind": "box",
      "center": [
        -10,
        1.425,
        -15.525
      ],
      "halfExtents": [
        0.7,
        1.425,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 19"
    },
    {
      "kind": "box",
      "center": [
        -10,
        1.5,
        -15.375
      ],
      "halfExtents": [
        0.7,
        1.5,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 20"
    },
    {
      "kind": "box",
      "center": [
        -10,
        1.575,
        -15.225
      ],
      "halfExtents": [
        0.7,
        1.575,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 21"
    },
    {
      "kind": "box",
      "center": [
        -10,
        1.6,
        -15.075
      ],
      "halfExtents": [
        0.7,
        1.6,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 22"
    },
    {
      "kind": "box",
      "center": [
        10.3,
        1.45,
        14.85
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house -8 north wall"
    },
    {
      "kind": "box",
      "center": [
        8,
        2.55,
        14.85
      ],
      "halfExtents": [
        0.6,
        0.35,
        0.15
      ],
      "material": "plaster",
      "note": "house -8 north lintel"
    },
    {
      "kind": "box",
      "center": [
        5.7,
        1.45,
        14.85
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house -8 north wall"
    },
    {
      "kind": "box",
      "center": [
        10.3,
        1.45,
        8.15
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house -8 south wall"
    },
    {
      "kind": "box",
      "center": [
        8,
        2.55,
        8.15
      ],
      "halfExtents": [
        0.6,
        0.35,
        0.15
      ],
      "material": "plaster",
      "note": "house -8 south lintel"
    },
    {
      "kind": "box",
      "center": [
        5.7,
        1.45,
        8.15
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house -8 south wall"
    },
    {
      "kind": "box",
      "center": [
        4.15,
        1.45,
        13.4
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house -8 east wall"
    },
    {
      "kind": "box",
      "center": [
        4.15,
        0.5,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.6
      ],
      "material": "plaster",
      "note": "house -8 east sill"
    },
    {
      "kind": "box",
      "center": [
        4.15,
        2.45,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.45,
        0.6
      ],
      "material": "plaster",
      "note": "house -8 east lintel"
    },
    {
      "kind": "box",
      "center": [
        4.15,
        1.45,
        9.6
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house -8 east wall"
    },
    {
      "kind": "box",
      "center": [
        11.85,
        1.45,
        13.4
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house -8 west wall"
    },
    {
      "kind": "box",
      "center": [
        11.85,
        0.5,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.6
      ],
      "material": "plaster",
      "note": "house -8 west sill"
    },
    {
      "kind": "box",
      "center": [
        11.85,
        2.45,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.45,
        0.6
      ],
      "material": "plaster",
      "note": "house -8 west lintel"
    },
    {
      "kind": "box",
      "center": [
        11.85,
        1.45,
        9.6
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house -8 west wall"
    },
    {
      "kind": "box",
      "center": [
        9.5,
        0.4,
        13.3
      ],
      "halfExtents": [
        0.8,
        0.4,
        0.4
      ],
      "material": "wood",
      "note": "table"
    },
    {
      "kind": "box",
      "center": [
        6.5,
        0.8,
        9.7
      ],
      "halfExtents": [
        0.6,
        0.8,
        0.3
      ],
      "material": "brick",
      "note": "hearth"
    },
    {
      "kind": "box",
      "center": [
        2.3,
        1.45,
        14.85
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 0 north wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        2.55,
        14.85
      ],
      "halfExtents": [
        0.6,
        0.35,
        0.15
      ],
      "material": "plaster",
      "note": "house 0 north lintel"
    },
    {
      "kind": "box",
      "center": [
        -2.3,
        1.45,
        14.85
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 0 north wall"
    },
    {
      "kind": "box",
      "center": [
        2.3,
        1.45,
        8.15
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 0 south wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        2.55,
        8.15
      ],
      "halfExtents": [
        0.6,
        0.35,
        0.15
      ],
      "material": "plaster",
      "note": "house 0 south lintel"
    },
    {
      "kind": "box",
      "center": [
        -2.3,
        1.45,
        8.15
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 0 south wall"
    },
    {
      "kind": "box",
      "center": [
        -3.85,
        1.45,
        13.4
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 0 east wall"
    },
    {
      "kind": "box",
      "center": [
        -3.85,
        0.5,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.6
      ],
      "material": "plaster",
      "note": "house 0 east sill"
    },
    {
      "kind": "box",
      "center": [
        -3.85,
        2.45,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.45,
        0.6
      ],
      "material": "plaster",
      "note": "house 0 east lintel"
    },
    {
      "kind": "box",
      "center": [
        -3.85,
        1.45,
        9.6
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 0 east wall"
    },
    {
      "kind": "box",
      "center": [
        3.85,
        1.45,
        13.4
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 0 west wall"
    },
    {
      "kind": "box",
      "center": [
        3.85,
        0.5,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.6
      ],
      "material": "plaster",
      "note": "house 0 west sill"
    },
    {
      "kind": "box",
      "center": [
        3.85,
        2.45,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.45,
        0.6
      ],
      "material": "plaster",
      "note": "house 0 west lintel"
    },
    {
      "kind": "box",
      "center": [
        3.85,
        1.45,
        9.6
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 0 west wall"
    },
    {
      "kind": "box",
      "center": [
        1.5,
        0.4,
        13.3
      ],
      "halfExtents": [
        0.8,
        0.4,
        0.4
      ],
      "material": "wood",
      "note": "table"
    },
    {
      "kind": "box",
      "center": [
        -1.5,
        0.8,
        9.7
      ],
      "halfExtents": [
        0.6,
        0.8,
        0.3
      ],
      "material": "brick",
      "note": "hearth"
    },
    {
      "kind": "box",
      "center": [
        -5.7,
        1.45,
        14.85
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 8 north wall"
    },
    {
      "kind": "box",
      "center": [
        -8,
        2.55,
        14.85
      ],
      "halfExtents": [
        0.6,
        0.35,
        0.15
      ],
      "material": "plaster",
      "note": "house 8 north lintel"
    },
    {
      "kind": "box",
      "center": [
        -10.3,
        1.45,
        14.85
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 8 north wall"
    },
    {
      "kind": "box",
      "center": [
        -5.7,
        1.45,
        8.15
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 8 south wall"
    },
    {
      "kind": "box",
      "center": [
        -8,
        2.55,
        8.15
      ],
      "halfExtents": [
        0.6,
        0.35,
        0.15
      ],
      "material": "plaster",
      "note": "house 8 south lintel"
    },
    {
      "kind": "box",
      "center": [
        -10.3,
        1.45,
        8.15
      ],
      "halfExtents": [
        1.7,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "house 8 south wall"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        1.45,
        13.4
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 8 east wall"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        0.5,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.6
      ],
      "material": "plaster",
      "note": "house 8 east sill"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        2.45,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.45,
        0.6
      ],
      "material": "plaster",
      "note": "house 8 east lintel"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        1.45,
        9.6
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 8 east wall"
    },
    {
      "kind": "box",
      "center": [
        -4.15,
        1.45,
        13.4
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 8 west wall"
    },
    {
      "kind": "box",
      "center": [
        -4.15,
        0.5,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.6
      ],
      "material": "plaster",
      "note": "house 8 west sill"
    },
    {
      "kind": "box",
      "center": [
        -4.15,
        2.45,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.45,
        0.6
      ],
      "material": "plaster",
      "note": "house 8 west lintel"
    },
    {
      "kind": "box",
      "center": [
        -4.15,
        1.45,
        9.6
      ],
      "halfExtents": [
        0.15,
        1.45,
        1.3
      ],
      "material": "plaster",
      "note": "house 8 west wall"
    },
    {
      "kind": "box",
      "center": [
        -6.5,
        0.4,
        13.3
      ],
      "halfExtents": [
        0.8,
        0.4,
        0.4
      ],
      "material": "wood",
      "note": "table"
    },
    {
      "kind": "box",
      "center": [
        -9.5,
        0.8,
        9.7
      ],
      "halfExtents": [
        0.6,
        0.8,
        0.3
      ],
      "material": "brick",
      "note": "hearth"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.05,
        11.5
      ],
      "halfExtents": [
        12,
        0.15,
        3.5
      ],
      "material": "wood",
      "note": "roof deck"
    },
    {
      "kind": "box",
      "center": [
        11.35,
        3.75,
        14.85
      ],
      "halfExtents": [
        0.65,
        0.55,
        0.15
      ],
      "material": "plaster",
      "note": "roof parapet north wall"
    },
    {
      "kind": "box",
      "center": [
        -1.35,
        3.75,
        14.85
      ],
      "halfExtents": [
        10.65,
        0.55,
        0.15
      ],
      "material": "plaster",
      "note": "roof parapet north wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.75,
        8.15
      ],
      "halfExtents": [
        12,
        0.55,
        0.15
      ],
      "material": "plaster",
      "note": "roof parapet south wall"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        3.75,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.55,
        3.2
      ],
      "material": "plaster",
      "note": "roof parapet east wall"
    },
    {
      "kind": "box",
      "center": [
        11.85,
        3.75,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.55,
        3.2
      ],
      "material": "plaster",
      "note": "roof parapet west wall"
    },
    {
      "kind": "box",
      "center": [
        4,
        3.75,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.55,
        3.2
      ],
      "material": "plaster",
      "note": "roof divider parapet"
    },
    {
      "kind": "box",
      "center": [
        -4,
        3.75,
        11.5
      ],
      "halfExtents": [
        0.15,
        0.55,
        3.2
      ],
      "material": "plaster",
      "note": "roof divider parapet"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.075,
        18.225
      ],
      "halfExtents": [
        0.7,
        0.075,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 1"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.15,
        18.075
      ],
      "halfExtents": [
        0.7,
        0.15,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 2"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.225,
        17.925
      ],
      "halfExtents": [
        0.7,
        0.225,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 3"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.3,
        17.775
      ],
      "halfExtents": [
        0.7,
        0.3,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 4"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.375,
        17.625
      ],
      "halfExtents": [
        0.7,
        0.375,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 5"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.45,
        17.475
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 6"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.525,
        17.325
      ],
      "halfExtents": [
        0.7,
        0.525,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 7"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.6,
        17.175
      ],
      "halfExtents": [
        0.7,
        0.6,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 8"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.675,
        17.025
      ],
      "halfExtents": [
        0.7,
        0.675,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 9"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.75,
        16.875
      ],
      "halfExtents": [
        0.7,
        0.75,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 10"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.825,
        16.725
      ],
      "halfExtents": [
        0.7,
        0.825,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 11"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.9,
        16.575
      ],
      "halfExtents": [
        0.7,
        0.9,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 12"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.975,
        16.425
      ],
      "halfExtents": [
        0.7,
        0.975,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 13"
    },
    {
      "kind": "box",
      "center": [
        10,
        1.05,
        16.275
      ],
      "halfExtents": [
        0.7,
        1.05,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 14"
    },
    {
      "kind": "box",
      "center": [
        10,
        1.125,
        16.125
      ],
      "halfExtents": [
        0.7,
        1.125,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 15"
    },
    {
      "kind": "box",
      "center": [
        10,
        1.2,
        15.975
      ],
      "halfExtents": [
        0.7,
        1.2,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 16"
    },
    {
      "kind": "box",
      "center": [
        10,
        1.275,
        15.825
      ],
      "halfExtents": [
        0.7,
        1.275,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 17"
    },
    {
      "kind": "box",
      "center": [
        10,
        1.35,
        15.675
      ],
      "halfExtents": [
        0.7,
        1.35,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 18"
    },
    {
      "kind": "box",
      "center": [
        10,
        1.425,
        15.525
      ],
      "halfExtents": [
        0.7,
        1.425,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 19"
    },
    {
      "kind": "box",
      "center": [
        10,
        1.5,
        15.375
      ],
      "halfExtents": [
        0.7,
        1.5,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 20"
    },
    {
      "kind": "box",
      "center": [
        10,
        1.575,
        15.225
      ],
      "halfExtents": [
        0.7,
        1.575,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 21"
    },
    {
      "kind": "box",
      "center": [
        10,
        1.6,
        15.075
      ],
      "halfExtents": [
        0.7,
        1.6,
        0.075
      ],
      "material": "plaster",
      "note": "roof stair step 22"
    },
    {
      "kind": "box",
      "center": [
        -6,
        2.4,
        -16.75
      ],
      "halfExtents": [
        0.3,
        0.05,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "arch lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -6,
        1.3,
        -18.225
      ],
      "halfExtents": [
        0.3,
        1.3,
        0.275
      ],
      "material": "plaster",
      "note": "arch pier"
    },
    {
      "kind": "box",
      "center": [
        -6,
        1.3,
        -15.275
      ],
      "halfExtents": [
        0.3,
        1.3,
        0.275
      ],
      "material": "plaster",
      "note": "arch pier"
    },
    {
      "kind": "box",
      "center": [
        -6,
        3.05,
        -16.75
      ],
      "halfExtents": [
        0.3,
        0.45,
        1.2
      ],
      "material": "plaster",
      "note": "arch lintel"
    },
    {
      "kind": "box",
      "center": [
        6,
        1.3,
        18.225
      ],
      "halfExtents": [
        0.3,
        1.3,
        0.275
      ],
      "material": "plaster",
      "note": "arch pier"
    },
    {
      "kind": "box",
      "center": [
        6,
        1.3,
        15.275
      ],
      "halfExtents": [
        0.3,
        1.3,
        0.275
      ],
      "material": "plaster",
      "note": "arch pier"
    },
    {
      "kind": "box",
      "center": [
        6,
        3.05,
        16.75
      ],
      "halfExtents": [
        0.3,
        0.45,
        1.2
      ],
      "material": "plaster",
      "note": "arch lintel"
    },
    {
      "kind": "box",
      "center": [
        6,
        2.4,
        -16.75
      ],
      "halfExtents": [
        0.3,
        0.05,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "arch lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        6,
        1.3,
        -18.225
      ],
      "halfExtents": [
        0.3,
        1.3,
        0.275
      ],
      "material": "plaster",
      "note": "arch pier"
    },
    {
      "kind": "box",
      "center": [
        6,
        1.3,
        -15.275
      ],
      "halfExtents": [
        0.3,
        1.3,
        0.275
      ],
      "material": "plaster",
      "note": "arch pier"
    },
    {
      "kind": "box",
      "center": [
        6,
        3.05,
        -16.75
      ],
      "halfExtents": [
        0.3,
        0.45,
        1.2
      ],
      "material": "plaster",
      "note": "arch lintel"
    },
    {
      "kind": "box",
      "center": [
        -6,
        1.3,
        18.225
      ],
      "halfExtents": [
        0.3,
        1.3,
        0.275
      ],
      "material": "plaster",
      "note": "arch pier"
    },
    {
      "kind": "box",
      "center": [
        -6,
        1.3,
        15.275
      ],
      "halfExtents": [
        0.3,
        1.3,
        0.275
      ],
      "material": "plaster",
      "note": "arch pier"
    },
    {
      "kind": "box",
      "center": [
        -6,
        3.05,
        16.75
      ],
      "halfExtents": [
        0.3,
        0.45,
        1.2
      ],
      "material": "plaster",
      "note": "arch lintel"
    },
    {
      "kind": "box",
      "center": [
        -2,
        0.2,
        -16.75
      ],
      "halfExtents": [
        0.75,
        0.2,
        0.75
      ],
      "material": "sand",
      "note": "sand mound"
    },
    {
      "kind": "box",
      "center": [
        2,
        0.2,
        16.75
      ],
      "halfExtents": [
        0.75,
        0.2,
        0.75
      ],
      "material": "sand",
      "note": "sand mound"
    },
    {
      "kind": "box",
      "center": [
        -9,
        0.4,
        -16.75
      ],
      "halfExtents": [
        0.6,
        0.4,
        0.6
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        9,
        0.4,
        16.75
      ],
      "halfExtents": [
        0.6,
        0.4,
        0.6
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        0,
        2.025,
        4
      ],
      "halfExtents": [
        0.04,
        1.125,
        0.04
      ],
      "material": "metal",
      "note": "fountain lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -21,
        2.525,
        -3.5
      ],
      "halfExtents": [
        0.04,
        0.075,
        0.04
      ],
      "material": "metal",
      "note": "gate lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -21,
        2.525,
        1.5
      ],
      "halfExtents": [
        0.04,
        0.075,
        0.04
      ],
      "material": "metal",
      "note": "gate lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -6,
        2.525,
        -16.75
      ],
      "halfExtents": [
        0.04,
        0.075,
        0.04
      ],
      "material": "metal",
      "note": "arch lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        6,
        2.525,
        -16.75
      ],
      "halfExtents": [
        0.04,
        0.075,
        0.04
      ],
      "material": "metal",
      "note": "arch lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -25.5,
        0.595,
        -3.5
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        -25.5,
        0.595,
        1.5
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        25.5,
        0.595,
        3.5
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        25.5,
        0.595,
        -1.5
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        11.5,
        0.595,
        -16.75
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        -11.5,
        0.595,
        16.75
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    }
  ],
  "spawns": [
    {
      "position": [
        -37,
        0.05,
        -5
      ],
      "yaw": 4.578,
      "team": 0
    },
    {
      "position": [
        37,
        0.05,
        5
      ],
      "yaw": 1.436,
      "team": 1
    },
    {
      "position": [
        -37,
        0.05,
        -3
      ],
      "yaw": 4.631,
      "team": 0
    },
    {
      "position": [
        37,
        0.05,
        3
      ],
      "yaw": 1.489,
      "team": 1
    },
    {
      "position": [
        -37,
        0.05,
        1
      ],
      "yaw": 4.739,
      "team": 0
    },
    {
      "position": [
        37,
        0.05,
        -1
      ],
      "yaw": 1.597,
      "team": 1
    },
    {
      "position": [
        -37,
        0.05,
        3
      ],
      "yaw": 4.793,
      "team": 0
    },
    {
      "position": [
        37,
        0.05,
        -3
      ],
      "yaw": 1.651,
      "team": 1
    },
    {
      "position": [
        -35,
        0.05,
        -5
      ],
      "yaw": 4.57,
      "team": 0
    },
    {
      "position": [
        35,
        0.05,
        5
      ],
      "yaw": 1.428,
      "team": 1
    },
    {
      "position": [
        -35,
        0.05,
        -3
      ],
      "yaw": 4.627,
      "team": 0
    },
    {
      "position": [
        35,
        0.05,
        3
      ],
      "yaw": 1.485,
      "team": 1
    },
    {
      "position": [
        -35,
        0.05,
        1
      ],
      "yaw": 4.741,
      "team": 0
    },
    {
      "position": [
        35,
        0.05,
        -1
      ],
      "yaw": 1.599,
      "team": 1
    },
    {
      "position": [
        -35,
        0.05,
        3
      ],
      "yaw": 4.798,
      "team": 0
    },
    {
      "position": [
        35,
        0.05,
        -3
      ],
      "yaw": 1.656,
      "team": 1
    }
  ],
  "props": [
    {
      "model": "/game/models/synty/props/crate-01.glb",
      "position": [
        -6.5,
        0.4,
        7.5
      ]
    },
    {
      "model": "/game/models/synty/props/crate-01.glb",
      "position": [
        6.5,
        0.4,
        -7.5
      ]
    },
    {
      "model": "/game/models/synty/props/barrel-01.glb",
      "position": [
        -6,
        0,
        8.3
      ]
    },
    {
      "model": "/game/models/synty/props/barrel-01.glb",
      "position": [
        6,
        0,
        -8.3
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        -25.5,
        0,
        -3.5
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        -25.5,
        0,
        1.5
      ]
    },
    {
      "model": "/game/models/synty/props/crate-large-01.glb",
      "position": [
        -30,
        0,
        -4.5
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        25.5,
        0,
        3.5
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        25.5,
        0,
        -1.5
      ]
    },
    {
      "model": "/game/models/synty/props/crate-large-01.glb",
      "position": [
        30,
        0,
        4.5
      ]
    },
    {
      "model": "/game/models/urban/pallet-broken.glb",
      "position": [
        2,
        0,
        -16.75
      ],
      "note": "cart stand-in"
    },
    {
      "model": "/game/models/urban/pallet-broken.glb",
      "position": [
        -2,
        0,
        16.75
      ],
      "note": "cart stand-in"
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        11.5,
        0,
        -16.75
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        -11.5,
        0,
        16.75
      ]
    },
    {
      "model": "/game/models/props/rock-a.glb",
      "position": [
        -9,
        0,
        -16.75
      ]
    },
    {
      "model": "/game/models/props/rock-a.glb",
      "position": [
        9,
        0,
        16.75
      ]
    }
  ],
  "lights": [
    {
      "kind": "spot",
      "position": [
        -36,
        7.5,
        -25
      ],
      "color": "#fff3e0",
      "intensity": 250,
      "distance": 26,
      "target": [
        -30,
        0,
        0
      ],
      "angle": 0.6,
      "penumbra": 0.4,
      "castShadow": true,
      "note": "tower flood over west courtyard"
    },
    {
      "kind": "spot",
      "position": [
        36,
        7.5,
        25
      ],
      "color": "#fff3e0",
      "intensity": 250,
      "distance": 26,
      "target": [
        30,
        0,
        0
      ],
      "angle": 0.6,
      "penumbra": 0.4,
      "castShadow": true,
      "note": "tower flood over west courtyard"
    },
    {
      "kind": "point",
      "position": [
        0,
        3.2,
        4
      ],
      "color": "#ffe3b0",
      "intensity": 35,
      "distance": 10,
      "note": "fountain lamp"
    },
    {
      "kind": "point",
      "position": [
        -8,
        2.3,
        6
      ],
      "color": "#ffcf90",
      "intensity": 25,
      "distance": 6,
      "note": "stall lamp"
    },
    {
      "kind": "point",
      "position": [
        8,
        2.3,
        -6
      ],
      "color": "#ffcf90",
      "intensity": 25,
      "distance": 6,
      "note": "stall lamp"
    },
    {
      "kind": "point",
      "position": [
        -8,
        2.3,
        -6
      ],
      "color": "#ffcf90",
      "intensity": 25,
      "distance": 6,
      "note": "stall lamp"
    },
    {
      "kind": "point",
      "position": [
        8,
        2.3,
        6
      ],
      "color": "#ffcf90",
      "intensity": 25,
      "distance": 6,
      "note": "stall lamp"
    },
    {
      "kind": "point",
      "position": [
        -21,
        2.4,
        -3.5
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 7,
      "note": "gate lamp"
    },
    {
      "kind": "point",
      "position": [
        -21,
        2.4,
        1.5
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 7,
      "note": "gate lamp"
    },
    {
      "kind": "point",
      "position": [
        21,
        2.4,
        3.5
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 7,
      "note": "gate lamp"
    },
    {
      "kind": "point",
      "position": [
        21,
        2.4,
        -1.5
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 7,
      "note": "gate lamp"
    },
    {
      "kind": "point",
      "position": [
        -8,
        2.8,
        -11.5
      ],
      "color": "#ffd8a0",
      "intensity": 40,
      "distance": 8,
      "note": "house interior lamp"
    },
    {
      "kind": "point",
      "position": [
        0,
        2.8,
        -11.5
      ],
      "color": "#ffd8a0",
      "intensity": 40,
      "distance": 8,
      "note": "house interior lamp"
    },
    {
      "kind": "point",
      "position": [
        8,
        2.8,
        -11.5
      ],
      "color": "#ffd8a0",
      "intensity": 40,
      "distance": 8,
      "note": "house interior lamp"
    },
    {
      "kind": "point",
      "position": [
        8,
        2.8,
        11.5
      ],
      "color": "#ffd8a0",
      "intensity": 40,
      "distance": 8,
      "note": "house interior lamp"
    },
    {
      "kind": "point",
      "position": [
        0,
        2.8,
        11.5
      ],
      "color": "#ffd8a0",
      "intensity": 40,
      "distance": 8,
      "note": "house interior lamp"
    },
    {
      "kind": "point",
      "position": [
        -8,
        2.8,
        11.5
      ],
      "color": "#ffd8a0",
      "intensity": 40,
      "distance": 8,
      "note": "house interior lamp"
    },
    {
      "kind": "point",
      "position": [
        -6,
        2.4,
        -16.75
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 7,
      "note": "arch lamp"
    },
    {
      "kind": "point",
      "position": [
        6,
        2.4,
        16.75
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 7,
      "note": "arch lamp"
    },
    {
      "kind": "point",
      "position": [
        6,
        2.4,
        -16.75
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 7,
      "note": "arch lamp"
    },
    {
      "kind": "point",
      "position": [
        -6,
        2.4,
        16.75
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 7,
      "note": "arch lamp"
    }
  ],
  "sites": [
    {
      "id": "A",
      "center": [
        -5,
        1,
        3
      ],
      "halfExtents": [
        4,
        2,
        4
      ]
    },
    {
      "id": "B",
      "center": [
        9,
        1,
        -16.5
      ],
      "halfExtents": [
        4,
        2,
        4
      ]
    }
  ]
}
